import React, {Component} from 'react';
import {Switch, Route,withRouter} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';

import { Request } from "./../../SYSTEM/Request"

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class GuestHomepage extends Component {

	constructor(props)
    {
        super(props);
        this.state = {}
    }

    renderHead = () =>
    {
        return (
            <div className="main_head">
                <div className="container">
                    <div className="main_head_content">
                        <div className="main_logo">
                            <img src="/system_images/logo.png" />
                        </div>
                        <a className="main_login_btn" onClick={() => this.props.openLogin(true)}>
                            Вход для поставщиков
                        </a>
                        <a className="main_partner_btn" onClick={() => this.props.openPartnership(true)}>
                            Сотрудничать
                        </a>
                        <a className="main_mob_login_btn" onClick={() => this.props.openLogin(true)}>
                            <img src="/system_images/mob_entrance.png" />
                        </a>
                    </div>
                </div>               
            </div>
        );
    }

    renderFirstRow = () =>
    {
        return (
            <div className="main_first">
                <div className="container">
                    <div className="main_first_content">
                        Присоединяйтесь к надёжному партнёру по доставке полезной еды
                    </div>
                </div>               
            </div>
        );
    }

    renderSecondRow = () =>
    {
        return (
            <div className="main_second">
                <div className="container">
                    <h2>Почему выбирают нас</h2>
                    <div className="main_two_columns_holder">
                        <div className="main_two_columns">

                            <div>
                                <div className="benefit">
                                    <div className="benefit_image">
                                        <img src="/system_images/benefits/1.png" />
                                    </div>
                                    <div className="benefit_text">
                                        Высокое качество и самый большой ассортимент органической продукции.
                                    </div>
                                </div>
                                <div className="benefit">
                                    <div className="benefit_image">
                                        <img src="/system_images/benefits/2.png" />
                                    </div>
                                    <div className="benefit_text">
                                        Собственная логистика с быстрой доставкой за 90 минут!
                                    </div>
                                </div>
                                <div className="benefit">
                                    <div className="benefit_image">
                                        <img src="/system_images/benefits/3.png" />
                                    </div>
                                    <div className="benefit_text">
                                        Собственная система сборки, разработанная по методике бережливого производства, которая позволяет собрать заказ в среднем за 20 секунд. Конкуренты собирают заказы по принципу «один заказ – один сборщик», что занимает 10-20 минут!
                                    </div>
                                </div>
                                <div className="benefit">
                                    <div className="benefit_image">
                                        <img src="/system_images/benefits/4.png" />
                                    </div>
                                    <div className="benefit_text">
                                        Контроль качества продукции на трех этапах:<br/>1. При поступлении 2. При сборке 3. При отправке.
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="benefit">
                                    <div className="benefit_image">
                                        <img src="/system_images/benefits/5.png" />
                                    </div>
                                    <div className="benefit_text">
                                        Мы работаем с проверенными поставщиками. Осуществляется выездная проверка. Сертификаты на органическую продукцию проверяются на подлинность.
                                    </div>
                                </div>
                                <div className="benefit">
                                    <div className="benefit_image">
                                        <img src="/system_images/benefits/6.png" />
                                    </div>
                                    <div className="benefit_text">
                                        Высокая клиентооретированность, благодаря которой мы достигли 40,2% возвратности наших клиентов на второй заказ.
                                    </div>
                                </div>
                                <div className="benefit">
                                    <div className="benefit_image">
                                        <img src="/system_images/benefits/7.png" />
                                    </div>
                                    <div className="benefit_text">
                                        Интересная и удобная система лояльности.
                                    </div>
                                </div>
                                <div className="benefit">
                                    <div className="benefit_image">
                                        <img src="/system_images/benefits/8.png" />
                                    </div>
                                    <div className="benefit_text">
                                        Доставка по всему городу и области в радиусе 100 км (Москва, Санкт-Петербург, Казань
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>       
            </div>
        );
    }

    renderThirdRow = () =>
    {
        return (
            <div className="main_third">
                <div className="container">
                    <h2>Выгоды для поставщика</h2>
                    <div className="main_three_columns">
                        <div>
                            <div className="main_first_text">
                                У нас более 50 000 заходов на сайт каждый день
                            </div>
                            <div className="main_second_text">
                                Ваш товар увидят и потенциально купят у нас большое количество клиентов.
                            </div>
                        </div>
                        <div>
                            <div className="main_first_text">
                                Каждый день более 20 блогеров делают рекламу товаров поставщиков
                            </div>
                            <div className="main_second_text">
                                Это блогеры от 100 тыс. до 22 миллионов. Мы бесплатно рекламируем ваш продукт, повышая узнаваемость, репутацию бренда, лояльность покупателя, а также увеличивая наш совместный оборот.
                            </div>
                        </div>
                        <div>
                            <div className="main_first_text">
                                Рекламируем товары в наших соцсетях
                            </div>
                            <div className="main_second_text">
                                Мы рекламируем товары в ТикТок аккаунте (около 200 тыс. подписчиков) а также в нашем Инстаграм аккаунте (более 300 тыс. подписчиков), рассказываем о пользе продукта и его выгодных характеристиках, в легкой, интересной и юмористической форме.
                            </div>
                        </div>
                    </div>
                </div>
                <img className="third_float" src="/system_images/third_float.png" />
                <img className="third_float2" src="/system_images/third_float_2.png" />    
            </div>
        );
    }

    renderFourthRow = () =>
    {
        return (
            <div className="main_fourth">
                <div className="container">
                    <h2>“Промо от поставщиков”</h2>
                    <div className="main_fourth_content">
                        <p>
                            У нас есть раздел - “Промо от поставщиков”, это второй раздел на сайте.
                        </p>
                        <p>
                            Механика простая: мы договариваемся с поставщиком на скидку минимум 20% на отгрузки в период акции. Мы транслируем скидку на сайте и поднимаем расположение товара на сайте, тем самым увеличивая узнаваемость и продажи
                        </p>
                    </div>
                    <div className="main_numbers">
                        <div className="main_numbers_holder">
                            <div>
                                В день от
                            </div>
                            <div>
                                7 000
                            </div>
                            <div>
                                заходов клиентов в раздел
                            </div>
                        </div>
                        <div className="main_numbers_holder">
                            <div>
                                Продажи в среднем растут в
                            </div>
                            <div>
                                4-5
                            </div>
                            <div>
                                раз
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderFivthRow = () =>
    {
        return (
            <div className="main_fivth">
                <div className="container">
                    <div className="main_fivth_content">
                        <h2>Маркетинг</h2>
                        <div>
                            Привлечём заказы с помощью нашего маркетинга и рекламы.
                        </div>
                        <div>
                            Наружная реклама.
                        </div>
                        <div>
                            Красиво снимаем ваш товар. По статистике, страница ресторана с профессиональными фотографиями увеличивает вероятность заказа на 50%.
                        </div>
                    </div>
                </div>               
            </div>
        );
    }

    ios = () =>
    {
        return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
        ].includes(navigator.platform)
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }

    renderMobileButton = () =>
    {
        if (typeof window.hide_mobile_activity !== "undefined") {
            if (window.hide_mobile_activity == true) {
                return '';
            }
        }
        if (this.ios()) {
            return (
                <a className="footer_store_icon" href="itms-apps://itunes.apple.com/app/apple-store/id1486148531"><img src="/system_images/footer_ios_green.png"/></a>
            );
        } else {
            return (
                <a className="footer_store_icon" href="https://play.google.com/store/apps/details?id=com.ecomarket_ooo"><img src="/system_images/footer_android_green.png"/></a>
            );
        }
    }

    renderFinalRow = () =>
    {
        return (
            <div className="main_footer">
                <div className="container">
                    <div className="main_footer_first">
                        <div className="main_footer_logo_mobile">
                            <img src="/system_images/logo.png" />
                        </div>
                        <a href="mailto: info@ecomarket.ru">info@ecomarket.ru</a>
                        <a href="tel: 74954450505">+7-(495)-445-05-05</a>
                        <div className="copyright">
                            Все права защищены ООО “Экомаркет.ру”
                        </div>
                        <div className="main_footer_logo">
                            <img src="/system_images/logo.png" />
                        </div>
                    </div>
                    <div className="main_footer_second">
                        <a href="https://ecomarket.ru" target="_blank">На сайт Ecomarket.ru</a>
                        <a href="https://ecomarket.ru" target="_blank">Ресторанам</a>
                        <a href="/" target="_blank">Поставщикам</a>
                    </div>
                    <div className="main_footer_last">
                        <div className="stores_intro">
                            <span>
                                Скачивайте наше приложение
                            </span>
                            <div>
                                <a href="https://play.google.com/store/apps/details?id=com.ecomarket_ooo" target="_blank">
                                    <img src="/system_images/pm_logo.png" />
                                </a>
                                <a href="itms-apps://itunes.apple.com/app/apple-store/id1486148531" target="_blank">
                                    <img src="/system_images/as_logo.png" />
                                </a>
                            </div>
                        </div>
                        <img className="footer_phone" src="/system_images/footer_phone.png" />
                    </div>
                </div>
                <div className="main_footer_apps">
                    <span>Скачивайте наше приложение</span>
                    {this.renderMobileButton()}
                </div>
            </div>
        );
    }

	render() { 
        return (
            <div className="main_component">
                {this.renderHead()}
                {this.renderFirstRow()}
                {this.renderSecondRow()}
                {this.renderThirdRow()}
                {this.renderFourthRow()}
                {this.renderFivthRow()}
                {this.renderFinalRow()}
            </div>
    	);
	}

}

export default withRouter(connect(
	mapStateToProps,
	mapDispatchToProps
)(GuestHomepage))
